import { type ShortUrlProps } from '~/components/ShowcaseModal/types';

export const MAX_SHOWCASE_DESCRIPTION_LENGTH = 16368;

export const DEFAULT_SHORT_URL_PROPS: ShortUrlProps = {
  disabled: false,
  passcode: null,
  expirationDate: null,
  presentationSettings: undefined,
  permissions: {
    asset: {
      canViewOriginal: false,
      canViewAllVersions: false,
      canManageDiscussions: false,
      canViewDiscussions: false,
    },
    customField: {
      canView: false,
      canManageApplications: false,
    },
    canvas: {
      canViewChatHistory: false,
    },
  },
};
